<tg-mobile-full-screen-dialog [fixedHeader]="true">
  <h1 class="title" i18n="Links clicks stats|title @@linkClicksStats.title">
    Клики по ссылкам
  </h1>
  @if (loading) {
    <tg-inline-loader></tg-inline-loader>
  }
  @if (stats && stats[data.channelId]) {
    <table>
      <thead>
        <tr>
          <th i18n="Links clicks stats|header @@linkClicksStats.tableHeader.clicks">Clicks</th>
          <th i18n="Links clicks stats|header @@linkClicksStats.tableHeader.url">Url</th>
        </tr>
        @for (link of stats[data.channelId]; track link) {
          <tr>
            <td><b>{{link.count}}</b></td>
            <td>{{link.url}}</td>
          </tr>
        }
      </thead>
    </table>
  }
</tg-mobile-full-screen-dialog>
